import { get, sync } from 'vuex-pathify';
import { GeoJSON } from 'ol/format';
import { extend } from 'ol/extent';
export default {
  computed: {
    isFilterActive: sync('map/isFilterActive'),
    filterPayload: sync('map/filterPayload'),
    originalOffersTree: get('featuresData/originalOffersTree'),
    offersTree: sync('featuresData/offersTree'),
    offersTreeFilterIds: sync('featuresData/offersTreeFilterIds'),
    offersCount: sync('featuresData/offersCount'),
    offersRanges: sync('featuresData/offersRanges'),
    offersLayersRanges: sync('featuresData/offersLayersRanges'),
    currentTree() {
      return this.offersTree[this.$i18n.locale];
    },
    currentTreeStatus() {
      return {
        layer: +this.$route.params.lid,
        voivodeship: +this.$route.query[0],
        district: +this.$route.query[1],
        commune: +this.$route.query[2],
        offer: +this.$route.params.fid,
      };
    },
    currentTreeStatusLayerId() {
      return this.currentTreeStatus['layer'] || null;
    },
  },
  methods: {
    filterLayers(ids) {
      Object.values(this.offersLayersIds[this.currentLng]).forEach(layerId => {
        this.toggleProjectLayer({ id: layerId, value: !ids.length || ids.includes(layerId) });
      });
    },
    filterVoivodeships(ids) {
      this.filterCartogramLayer('voivodeship', ids);
    },
    filterDistricts(ids) {
      this.filterCartogramLayer('district', ids);
    },
    filterCommunes(ids) {
      this.filterCartogramLayer('commune', ids);
    },
    filterCartogramLayer(type, ids) {
      const source = this.getLayerBy(this.offersCartogramLayersIds[type], {
        group: 'offersCartogramLayers',
      })?.getSource();
      let geojson = JSON.parse(JSON.stringify(this.projectLayersGeojsons[this.offersCartogramLayersIds[type]]));
      geojson['features'] = geojson.features.filter(feature => ids.includes(feature.id));
      source.clear();
      source.addFeatures(
        source.getFormat().readFeatures(geojson, {
          dataProjection: geojson.crs.properties.name,
          featureProjection: this.$_config.mapDataCoordinateSystem.epsg,
        })
      );
    },
    setTreeFilter(treeStatus = this.currentTreeStatus) {
      this.offersTreeFilterIds = this.getTreeFilter(treeStatus);
    },
    getTreeFilter(treeStatus = this.currentTreeStatus) {
      const currentLayer = this.currentTree?.find(layer => layer.id === treeStatus['layer']);
      const currentVoivodeship = currentLayer?.children.find(v => v.id === treeStatus['voivodeship']);
      const currentDistrict = currentVoivodeship?.children.find(v => v.id === treeStatus['district']);
      const currentCommune = currentDistrict?.children.find(v => v.id === treeStatus['commune']);

      let voivodeship = [];
      if (currentVoivodeship) {
        voivodeship = [currentVoivodeship.id];
      } else if (currentLayer) {
        voivodeship = this.$_flattenStructure(currentLayer.children, 'children', 1)?.map(el => el.id);
      } else {
        voivodeship = this.$_flattenStructure(this.currentTree, 'children', 2)?.map(el => el.id);
      }

      let district = [];
      if (currentDistrict) {
        district = [currentDistrict.id];
      } else if (currentVoivodeship) {
        district = this.$_flattenStructure(currentVoivodeship.children, 'children', 1)?.map(el => el.id);
      } else if (currentLayer) {
        district = this.$_flattenStructure(currentLayer.children, 'children', 2)?.map(el => el.id);
      } else {
        district = this.$_flattenStructure(this.currentTree, 'children', 3)?.map(el => el.id);
      }

      let commune = [];
      if (currentCommune) {
        commune = [currentCommune.id];
      } else if (currentDistrict) {
        commune = this.$_flattenStructure(currentDistrict.children, 'children', 1)?.map(el => el.id);
      } else if (currentVoivodeship) {
        commune = this.$_flattenStructure(currentVoivodeship.children, 'children', 2)?.map(el => el.id);
      } else if (currentLayer) {
        commune = this.$_flattenStructure(currentLayer.children, 'children', 3)?.map(el => el.id);
      } else {
        commune = this.$_flattenStructure(this.currentTree, 'children', 4)?.map(el => el.id);
      }

      let offer = [];
      if (currentCommune) {
        offer = this.$_flattenStructure(currentCommune.children, 'children', 1)?.map(el => el.id);
      } else if (currentDistrict) {
        offer = this.$_flattenStructure(currentDistrict.children, 'children', 2)?.map(el => el.id);
      } else if (currentVoivodeship) {
        offer = this.$_flattenStructure(currentVoivodeship.children, 'children', 3)?.map(el => el.id);
      } else if (currentLayer) {
        offer = this.$_flattenStructure(currentLayer.children, 'children', 4)?.map(el => el.id);
      } else {
        offer = this.$_flattenStructure(this.currentTree, 'children', 5)?.map(el => el.id);
      }

      return {
        layer: currentLayer ? [currentLayer.id] : [],
        voivodeship,
        district,
        commune,
        offer,
      };
    },
    setOffersCounts(filter = this.offersTreeFilterIds) {
      this.offersCount = this.getOffersCount(filter);
    },
    getOffersCount(filter = this.offersTreeFilterIds) {
      return this.$_config.languages.reduce((total, lng) => {
        total[lng] = {
          voivodeship: {},
          district: {},
          commune: {},
        };

        this.offersTree[lng]
          .filter(layer => !filter['layer'].length || filter['layer']?.includes(layer.id))
          .map(layer => {
            const voivodeships = layer.children
              .filter(voivodeship => !filter['voivodeship'] || filter['voivodeship']?.includes(voivodeship.id))
              .map(voivodeship => {
                const districts = voivodeship.children
                  .filter(district => !filter['district'] || filter['district']?.includes(district.id))
                  .map(district => {
                    const communes = district.children
                      .filter(commune => !filter['commune'] || filter['commune']?.includes(commune.id))
                      .map(commune => {
                        const communeOffersCount = commune.children.length;
                        const communeAreaCount = this.$_summarizeArrayOfObjectsKey(commune.children, 'area');
                        total[lng]['commune'][commune.id] = {
                          count: (total[lng]['commune'][commune.id]?.count || 0) + communeOffersCount,
                          area: (total[lng]['commune'][commune.id]?.area || 0) + communeAreaCount,
                        };
                        return { ...commune, count: communeOffersCount, area: communeAreaCount };
                      });
                    const districtOffersCount = this.$_summarizeArrayOfObjectsKey(communes, 'count');
                    const districtOffersArea = this.$_summarizeArrayOfObjectsKey(communes, 'area');
                    total[lng]['district'][district.id] = {
                      count: (total[lng]['district'][district.id]?.count || 0) + districtOffersCount,
                      area: (total[lng]['district'][district.id]?.area || 0) + districtOffersArea,
                    };
                    return { ...district, children: communes, area: districtOffersArea, count: districtOffersCount };
                  });
                const voivodeshipOffersCount = this.$_summarizeArrayOfObjectsKey(districts, 'count');
                const voivodeshipOffersArea = this.$_summarizeArrayOfObjectsKey(districts, 'area');
                total[lng]['voivodeship'][voivodeship.id] = {
                  count: (total[lng]['voivodeship'][voivodeship.id]?.count || 0) + voivodeshipOffersCount,
                  area: (total[lng]['voivodeship'][voivodeship.id]?.area || 0) + voivodeshipOffersArea,
                };
                return {
                  ...voivodeship,
                  children: districts,
                  area: voivodeshipOffersArea,
                  count: voivodeshipOffersCount,
                };
              });
            const layerOffersCount = this.$_summarizeArrayOfObjectsKey(voivodeships, 'count');
            const layerOffersArea = this.$_summarizeArrayOfObjectsKey(voivodeships, 'area');
            return { ...layer, children: voivodeships, area: layerOffersArea, count: layerOffersCount };
          });

        return total;
      }, {});
    },
    zoomToCurrentTreeStatusExtent(type, treeElement, layersIds = []) {
      const featuresIds = treeElement.children.map(children => children.id);
      const layersFeatures = layersIds?.length
        ? layersIds.reduce((total, current) => {
            total = [...total, ...this.projectLayersGeojsons[current]?.features];
            return total;
          }, [])
        : this.projectLayersGeojsons[this.offersCartogramLayersIds[type]]?.features;
      const features = layersFeatures?.filter(feature => featuresIds.includes(feature.id));
      let extent;
      features.forEach(feature => {
        const olGeometry = new GeoJSON().readGeometry(feature.geometry, {
          dataProjection: this.$_config.mapDataCoordinateSystem?.epsg,
          featureProjection: this.$_config.mapDataCoordinateSystem?.epsg,
        });
        if (!extent) extent = olGeometry.getExtent();
        else extent = extend(extent, olGeometry.getExtent());
      });
      const minZoomsDict = {
        district: 8,
        commune: 11,
        offer: 14,
      };
      this.fitView({ value: extent, options: { ...(minZoomsDict[type] ? { minZoom: minZoomsDict[type] } : {}) } });
    },
    fitViewToCurrentTreeStatus(type, treeStatus = this.currentTreeStatus) {
      const treeLayer = this.currentTree?.find(layer => layer.id === treeStatus['layer']);
      if (!treeLayer) return;
      const treeVoivodeship = treeLayer.children?.find(voivodeship => voivodeship.id === treeStatus['voivodeship']);
      if (!treeVoivodeship) return;
      if (type === 'voivodeship') {
        this.zoomToCurrentTreeStatusExtent('district', treeVoivodeship);
      } else {
        const treeDistrict = treeVoivodeship.children?.find(district => district.id === treeStatus['district']);
        if (!treeDistrict) return;
        if (type === 'district') {
          this.zoomToCurrentTreeStatusExtent('commune', treeDistrict);
        } else {
          const treeCommune = treeDistrict.children?.find(commune => commune.id === treeStatus['commune']);
          if (!treeCommune) return;
          if (type === 'commune') {
            this.zoomToCurrentTreeStatusExtent('offer', treeCommune, [treeLayer.id]);
          }
        }
      }
    },
    fitViewToMergedClusterElement(feature) {
      if (feature.type === 'voivodeship') {
        const districts = this.currentTree.reduce((total, layer) => {
          const voivodeship = layer.children.find(v => v.id === feature.id);
          voivodeship?.children.forEach(district => {
            if (!total.find(d => d.id === district.id)) total.push(district);
          });
          return total;
        }, []);
        this.zoomToCurrentTreeStatusExtent('district', { children: districts });
      } else if (feature.type === 'district') {
        const communes = this.currentTree.reduce((total, layer) => {
          const district = layer.children
            .find(v => v.children.find(d => d.id === feature.id))
            ?.children.find(d => d.id === feature.id);
          district?.children.forEach(commune => {
            if (!total.find(c => c.id === commune.id)) total.push(commune);
          });
          return total;
        }, []);
        this.zoomToCurrentTreeStatusExtent('commune', { children: communes });
      } else if (feature.type === 'commune') {
        const offers = this.currentTree.reduce((total, layer) => {
          const district = layer.children
            .find(v => v.children.find(d => d.children.find(c => c.id === feature.id)))
            ?.children.find(d => d.children.find(c => c.id === feature.id));
          const commune = district?.children.find(c => c.id === feature.id);
          commune?.children.forEach(offer => {
            if (!total.find(o => o.id === offer.id)) total.push(offer);
          });
          return total;
        }, []);
        this.zoomToCurrentTreeStatusExtent(
          'offer',
          { children: offers },
          Object.values(this.offersLayersIds[this.currentLng])
        );
      }
    },
    fitViewToDefault() {
      this.setView({ zoom: this.$_config.mapDefaultZoom, center: this.$_config.mapDataCoordinateSystem?.center });
    },
    zoomToCurrentTreeStatus(nV = this.currentTreeStatus, oV = {}) {
      const changes = {};
      Object.keys(nV).forEach(key => {
        if (nV[key] !== oV?.[key]) changes[key] = nV[key];
      });
      if (changes['offer'] || changes['offer'] === 0) {
        this.zoomToProjectLayerFeature({ lid: nV['layer'], fid: nV['offer'] });
      } else if (changes['commune'] || changes['commune'] === 0) {
        this.fitViewToCurrentTreeStatus('commune', nV);
      } else if (changes['district'] || changes['district'] === 0) {
        this.fitViewToCurrentTreeStatus('district', nV);
      } else if (changes['voivodeship'] || changes['voivodeship'] === 0) {
        this.fitViewToDefault();
      } else if (changes['layer'] || changes['layer'] === 0) {
        this.fitViewToDefault();
      } else if (Object.hasOwn(changes, 'layer') && !changes['layer']) {
        this.fitViewToDefault();
      } else if (Object.hasOwn(changes, 'voivodeship') && !changes['voivodeship']) {
        this.fitViewToDefault();
      } else if (Object.hasOwn(changes, 'district') && !changes['district']) {
        this.fitViewToDefault();
      } else if (Object.hasOwn(changes, 'commune') && !changes['commune']) {
        this.fitViewToCurrentTreeStatus('district', nV);
      } else if (Object.hasOwn(changes, 'offer') && !changes['offer']) {
        this.fitViewToCurrentTreeStatus('commune', nV);
      }
    },
    clearFilter() {
      this.offersTree = Object.freeze(this.originalOffersTree);
      this.isFilterActive = false;
      this.filterPayload = {};
      Object.values(this.offersLayersIds[this.currentLng]).forEach(layerId => {
        this.$root.$emit('refreshLayerSource', layerId, { by: 'id', group: 'projectLayers' });
      });
    },
  },
  watch: {
    currentTreeStatus: {
      handler(nV, oV) {
        this.setTreeFilter(nV);
        this.zoomToCurrentTreeStatus(nV, oV);
      },
      deep: true,
      immediate: false,
    },
    offersTreeFilterIds: {
      handler(nV) {
        Object.keys(nV).forEach(key => {
          if (key !== 'offer') {
            this[`filter${this.$_capitalize(key)}s`](nV[key]);
          }
        });
        this.setOffersCounts(nV);
      },
      deep: true,
    },
    offersTree() {
      this.setTreeFilter();
    },
  },
  mounted() {
    this.$root.$off('zoomToCurrentTreeStatus');
    this.$root.$on('zoomToCurrentTreeStatus', this.zoomToCurrentTreeStatus);
  },
};
